import React from 'react';
import './DataTips.scss';


function DataTips(props){
    if( props.type === 'noData'){
        return (
            <div className="m-data-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">{props.txt || '还没有关注的主播哦～'}</h6>
            </div>
        );
    }

    if( props.type === 'noHomeData'){
        return (
            <div className="m-data-tips m-home-data-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">{props.txt || '该分类暂无主播开播~'}</h6>
            </div>
        );
    }


    if( props.type === 'noLogin'){
        return (
            <div className="m-data-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">登录后才可以查看已订阅主播哦～</h6>
                <div className="btn-login clickstat" data-stat="Click/sub/login|点击/订阅/登录" onClick={props.handleLog}>立即登录</div>
            </div>
        );
    }

    if( props.type === 'liveReload'){
        return (
            <div className="m-data-tips m-room-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">直播加载失败，请观看其他直播～</h6>
                <div className="btn-reload clickstat" data-stat="Click/zhibo/redown|点击/直播间/重新加载" onClick={props.handleClick}>重新加载</div>
            </div>
        );
    }

    if( props.type === 'liveOff'){
        return (
            <div className="m-data-tips m-room-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">主播已经下播了，去看看其他直播吧～</h6>
            </div>
        );
    }

    if( props.type === 'liveNoExist'){
        return (
            <div className="m-data-tips m-room-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">主播不存在，去看看其他主播吧～</h6>
            </div>
        );
    }

    if( props.type === 'netError'){
        return (
            <div className="m-data-tips m-room-tips">
                <div className="tips-bg"></div>
                <h6 className="tips-text">网络异常，请检查网络后刷新～</h6>
                <div className="btn-reload clickstat" data-stat="Click/zhibo/redown|点击/直播间/重新加载" onClick={props.handleClick}>重新加载</div>
            </div>
        );
    }


    

}

export default DataTips;


// WEBPACK FOOTER //
// ./src/common/components/data-tips/DataTips.jsx